import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'digicem-success-dialog',
  templateUrl: './success-dialog.component.html',
})
export class SuccessDialogComponent {
  public title: string = 'Operación exitosa';
  public message: string = 'La operación se ha completado con éxito.';
  public buttonText: string = 'Aceptar';

  constructor(
    private dialogRef: MatDialogRef<SuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      buttonText: string;
    },
  ) {
    this.title = data.title || this.title;
    this.message = data.message || this.message;
    this.buttonText = data.buttonText || this.buttonText;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
